module.exports = __webpack_public_path__ + "img/img-3-mobile.1da8ea2d.png";